module.exports = __webpack_public_path__ + "media/s.a04f8f01.mp3";